.fill-container
  align-items center
  background-color var(--background-color)
  border-bottom-left-radius var(--error-boundary-radius)
  border-bottom-right-radius var(--error-boundary-radius)
  display flex
  flex-direction row
  height 100%
  justify-content center
  width 100%

  &.full-screen
    height 100vh
    width 100vw
